/* L for You — 最小限のJS
   1) ヘッダー（アナウンスバー含む）の高さを --lfy-header-h に渡し、HEROをファーストビューに収める
   2) 商品ページのアコーディオン見出し「WHY WE MADE IT｜この商品が生まれた背景」を
      英字＋小さな日本語の2行に分割（テキストを読み替えるだけで、開閉機能には触れない） */
(() => {
  const root = document.documentElement;

  const measure = () => {
    let groups = document.querySelectorAll('.shopify-section-group-header-group');
    if (!groups.length) {
      groups = document.querySelectorAll('#shopify-section-announcement-bar, #shopify-section-header');
    }
    let h = 0;
    groups.forEach((el) => { h += el.offsetHeight; });
    root.style.setProperty('--lfy-header-h', `${h}px`);
  };

  const splitAccordionTitles = (scope = document) => {
    scope.querySelectorAll('.product__accordion .accordion__title').forEach((el) => {
      if (el.dataset.lfySplit) return;
      const parts = el.textContent.split(/[｜|]/);
      if (parts.length < 2) return;
      const en = document.createElement('span');
      en.className = 'lfy-acc__en';
      en.textContent = parts[0].trim();
      const ja = document.createElement('span');
      ja.className = 'lfy-acc__ja';
      ja.textContent = parts.slice(1).join(' ').trim();
      el.replaceChildren(en, ja);
      el.dataset.lfySplit = '1';
    });
  };

  /* PCではマウスを乗せるだけでドロップダウンを開く（Dawn標準はクリックのみ）。
     タッチ端末・スマホのドロワーメニューには影響しない */
  const hoverMenus = () => {
    if (!window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;
    document.querySelectorAll('.header__inline-menu header-menu details').forEach((details) => {
      if (details.dataset.lfyHover) return;
      details.dataset.lfyHover = '1';
      const item = details.closest('li') || details;
      const summary = details.querySelector('summary');
      let timer;
      item.addEventListener('mouseenter', () => {
        clearTimeout(timer);
        if (!details.hasAttribute('open')) {
          details.setAttribute('open', '');
          if (summary) summary.setAttribute('aria-expanded', 'true');
        }
      });
      item.addEventListener('mouseleave', () => {
        timer = setTimeout(() => {
          details.removeAttribute('open');
          if (summary) summary.setAttribute('aria-expanded', 'false');
        }, 180);
      });
    });
  };

  /* 商品カードの「カートに入れる」：ページ遷移せずに追加し、Dawn標準のカート通知（またはカートドロワー）を表示。
     JSが動かない環境では通常のフォーム送信でカートページへ移動する */
  const bindQuickAdd = () => {
    if (window.__lfyQuickAdd) return;
    window.__lfyQuickAdd = true;
    document.addEventListener('submit', async (event) => {
      const form = event.target.closest && event.target.closest('form[data-lfy-add]');
      if (!form) return;
      event.preventDefault();
      const button = form.querySelector('button');
      const label = form.querySelector('.lfy-prod__add-label');
      const msg = form.querySelector('.lfy-prod__msg');
      const original = label ? label.textContent : '';
      const cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      const body = new FormData(form);
      if (cart && typeof cart.getSectionsToRender === 'function') {
        body.append('sections', cart.getSectionsToRender().map((s) => s.id));
        body.append('sections_url', window.location.pathname);
        if (typeof cart.setActiveElement === 'function') cart.setActiveElement(document.activeElement);
      }
      button.disabled = true;
      button.setAttribute('aria-busy', 'true');
      if (msg) msg.textContent = '';
      try {
        const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
        const res = await fetch(`${root}cart/add.js`, {
          method: 'POST',
          headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
          body,
        });
        const data = await res.json();
        if (!res.ok || data.status) {
          if (msg) msg.textContent = data.description || data.message || 'カートに追加できませんでした。';
          return;
        }
        if (cart && typeof cart.renderContents === 'function' && data.sections) {
          cart.classList.remove('is-empty');
          cart.renderContents(data);
        } else {
          window.location.href = `${root}cart`;
          return;
        }
        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          publish(PUB_SUB_EVENTS.cartUpdate, { source: 'lfy-quick-add', productVariantId: body.get('id'), cartData: data });
        }
        if (label) {
          label.textContent = '追加しました ✓';
          setTimeout(() => { label.textContent = original; }, 2000);
        }
      } catch (e) {
        form.submit();
      } finally {
        button.disabled = false;
        button.removeAttribute('aria-busy');
      }
    });
  };

  const reduceMotion = () => window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* HERO：背景写真のフェード切り替え（文字は固定）。
     一時停止ボタンあり／「視差効果を減らす」設定時は自動再生しない／タブ非表示中は停止 */
  const initHeroFade = (root = document) => {
    root.querySelectorAll('[data-lfy-fade]').forEach((media) => {
      if (media.__lfyFade) return;
      const slides = Array.from(media.querySelectorAll('.lfy-hero__slide'));
      if (slides.length < 2) return;
      media.__lfyFade = true;
      const section = media.closest('.lfy-hero');
      const counter = section && section.querySelector('[data-lfy-current]');
      const button = section && section.querySelector('.lfy-hero__pause');
      const interval = (parseFloat(media.dataset.interval) || 6) * 1000;
      let index = 0;
      let timer = null;
      let paused = reduceMotion();

      const warm = (n) => {
        const img = slides[(n + slides.length) % slides.length].querySelector('img[loading="lazy"]');
        if (img) img.loading = 'eager';
      };
      const show = (n) => {
        slides[index].classList.remove('is-active');
        slides[index].setAttribute('aria-hidden', 'true');
        index = (n + slides.length) % slides.length;
        slides[index].classList.add('is-active');
        slides[index].removeAttribute('aria-hidden');
        warm(index);
        warm(index + 1);
        if (counter) counter.textContent = String(index + 1);
      };
      const stop = () => { clearInterval(timer); timer = null; };
      const start = () => { stop(); if (!paused && !document.hidden) timer = setInterval(() => show(index + 1), interval); };
      const syncButton = () => {
        if (!button) return;
        button.setAttribute('aria-pressed', String(paused));
        button.setAttribute('aria-label', paused ? '背景のスライドを再生' : '背景のスライドを一時停止');
      };

      if (button) button.addEventListener('click', () => { paused = !paused; syncButton(); paused ? stop() : start(); });
      document.addEventListener('visibilitychange', () => (document.hidden ? stop() : start()));
      document.addEventListener('shopify:block:select', (e) => {
        const i = slides.indexOf(e.target);
        if (i > -1) { stop(); show(i); }
      });
      document.addEventListener('shopify:block:deselect', (e) => { if (slides.includes(e.target)) start(); });

      if (document.readyState === 'complete') warm(1); else window.addEventListener('load', () => warm(1), { once: true });
      syncButton();
      start();
    });
  };

  /* 小バナーのスライダー：前後ボタン・スクロール位置のバー・任意の自動スライド */
  const initSliders = (root = document) => {
    root.querySelectorAll('[data-lfy-slider]').forEach((el) => {
      if (el.__lfySlider) return;
      const track = el.querySelector('[data-track]');
      if (!track) return;
      el.__lfySlider = true;
      const prev = el.querySelector('[data-prev]');
      const next = el.querySelector('[data-next]');
      const bar = el.querySelector('[data-progress]');
      const pauseBtn = el.querySelector('[data-pause]');
      const behavior = reduceMotion() ? 'auto' : 'smooth';

      const step = () => {
        const item = track.querySelector('li');
        const gap = parseFloat(getComputedStyle(track).columnGap) || 0;
        return item ? item.getBoundingClientRect().width + gap : track.clientWidth;
      };
      const update = () => {
        const max = track.scrollWidth - track.clientWidth;
        if (prev) prev.disabled = track.scrollLeft <= 2;
        if (next) next.disabled = track.scrollLeft >= max - 2;
        if (bar) {
          const visible = Math.min(1, track.clientWidth / track.scrollWidth);
          bar.style.setProperty('--w', `${visible * 100}%`);
          bar.style.setProperty('--x', max > 0 ? `${(track.scrollLeft / max) * (100 - visible * 100)}%` : '0%');
        }
        el.classList.toggle('is-static', max <= 2);
      };
      const go = (dir) => {
        const max = track.scrollWidth - track.clientWidth;
        if (dir > 0 && track.scrollLeft >= max - 2) track.scrollTo({ left: 0, behavior });
        else track.scrollBy({ left: dir * step(), behavior });
      };

      if (prev) prev.addEventListener('click', () => go(-1));
      if (next) next.addEventListener('click', () => go(1));
      let raf;
      track.addEventListener('scroll', () => { cancelAnimationFrame(raf); raf = requestAnimationFrame(update); }, { passive: true });
      window.addEventListener('resize', update, { passive: true });

      if (el.dataset.autoplay === 'true') {
        const interval = (parseFloat(el.dataset.interval) || 5) * 1000;
        let paused = reduceMotion();
        let hover = false;
        let timer = null;
        const stop = () => { clearInterval(timer); timer = null; };
        const start = () => { stop(); if (!paused && !hover && !document.hidden) timer = setInterval(() => go(1), interval); };
        const sync = () => {
          if (!pauseBtn) return;
          pauseBtn.setAttribute('aria-pressed', String(paused));
          pauseBtn.setAttribute('aria-label', paused ? '自動スライドを再生' : '自動スライドを一時停止');
        };
        if (pauseBtn) pauseBtn.addEventListener('click', () => { paused = !paused; sync(); start(); });
        el.addEventListener('mouseenter', () => { hover = true; stop(); });
        el.addEventListener('mouseleave', () => { hover = false; start(); });
        el.addEventListener('focusin', () => { hover = true; stop(); });
        el.addEventListener('focusout', () => { hover = false; start(); });
        document.addEventListener('visibilitychange', () => (document.hidden ? stop() : start()));
        sync();
        start();
      }
      document.addEventListener('shopify:block:select', (e) => {
        if (track.contains(e.target)) track.scrollTo({ left: e.target.offsetLeft - track.offsetLeft, behavior });
      });
      update();
    });
  };

  /* フッターのリンク列：スマホでは閉じた状態（タップで開く）、PCでは常に開く */
  const footerMq = window.matchMedia('(max-width: 749px)');
  const syncFooter = () => {
    document.querySelectorAll('[data-lfy-footer-acc]').forEach((d) => { d.open = !footerMq.matches; });
  };
  if (footerMq.addEventListener) footerMq.addEventListener('change', syncFooter);

  const init = () => {
    syncFooter();
    initHeroFade();
    initSliders();
    bindQuickAdd();
    hoverMenus();
    measure();
    splitAccordionTitles();
    // バリエーション切替でDawnが商品情報を再描画したときにも再適用
    const main = document.getElementById('MainContent');
    if (main && 'MutationObserver' in window) {
      let t;
      new MutationObserver(() => {
        clearTimeout(t);
        t = setTimeout(() => splitAccordionTitles(main), 50);
      }).observe(main, { childList: true, subtree: true });
    }
  };

  let raf;
  window.addEventListener('resize', () => {
    cancelAnimationFrame(raf);
    raf = requestAnimationFrame(measure);
  }, { passive: true });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', (e) => {
    syncFooter();
    initHeroFade(e.target);
    initSliders(e.target);
    hoverMenus();
    measure();
    splitAccordionTitles(e.target);
  });
})();
